import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { Button, Col, Form, Row } from 'react-bootstrap'
import resAddComment from './resolvers/resAddComment'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from './utils/prepareSubmitForm'
import submitForm from './utils/submitForm'

interface AddCommentProps {
  id: string
  dependency: number
  setDependency: Function
}

const AddComment: React.FunctionComponent<AddCommentProps> = (props: AddCommentProps) => {
  const [showOverlay, setShowOverlay] = useState<boolean>(false)
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false)

  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    reset,
    setFocus,
    formState: { errors },
    setValue,
  } = useForm({
    mode: 'all',
    resolver: resAddComment,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Form
      onSubmit={handleSubmit((data) =>
        prepareSubmitForm({
          submitForm,
          navigate,
          data,
          id: props.id,
          name: 'Comment',
          optionalParameters: {
            setIsFormSubmitted: setIsFormSubmitted,
            dependency: props.dependency,
            setDependency: props.setDependency,
            reset: reset,
          },
        }),
      )}
      id='add-comment-form'
    >
      <Row>
        <Col md={10}>
          <Form.Group className='form-group'>
            <Form.Control
              type='text'
              placeholder='Enter comment text here...'
              {...register('text')}
            />
            {errors && errors['text'] && <p className='error'>{errors['text'].message}</p>}
          </Form.Group>
        </Col>
        <Col md={2} className='text-center'>
          <Button disabled={isFormSubmitted} type='submit' className='btn-round btn-primary'>
            {isFormSubmitted && (
              <>
                <span
                  className='spinner-border spinner-border-sm'
                  role='status'
                  aria-hidden='true'
                ></span>
                &nbsp;
              </>
            )}
            Add
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

export default AddComment
